import fetch from "../utils/fetch";
import env from "../env";

export function GetUnidade(idUnidade) {
    return fetch(env.apiUrl+"api/unidade/get/" + idUnidade, {
        method: "GET",
        mode: "cors",
    })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    error: "Ocorreu um erro contate o administrador."
                });
                console.log(error);
            }
        )
        .catch(error => {
            console.log(error.message);
        });


}
